import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Element from 'element-ui'
import { CarbonIconsVue } from '@carbon/icons-vue'
import User32 from '@carbon/icons-vue/es/user/32'
import Package32 from '@carbon/icons-vue/es/package/32'
import Purchase32 from '@carbon/icons-vue/es/purchase/32'
import Playlist32 from '@carbon/icons-vue/es/playlist/32'
import Star32 from '@carbon/icons-vue/es/star/32'
import List32 from '@carbon/icons-vue/es/list/32'
import Logout32 from '@carbon/icons-vue/es/logout/32'
import './style/element_variables.scss'
import './../node_modules/slick-carousel/slick/slick.scss'

Vue.config.productionTip = false

Vue.use(Element)
Vue.use(CarbonIconsVue, {
  components: {
    User32,
    Package32,
    List32,
    Playlist32,
    Logout32,
    Star32,
    Purchase32,
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
